import { render, staticRenderFns } from "./location-dialog.vue?vue&type=template&id=2f806b57&"
import script from "./location-dialog.vue?vue&type=script&lang=js&"
export * from "./location-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VContainer,VDialog,VSwitch})
